import styled from "@emotion/styled";
import { black } from "@stepfinance/react";
import React from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { CurrentUserBadge } from "../CurrentUserBadge";
import { AddressInput } from "./AddressInput";
import { appBarMenuPopoverStyles } from "./SettingsMenu";
import { WalletConnect } from "./WalletConnect";
import { WalletMenuConnected } from "./WalletMenuConnected";

export const MobileWalletMenu: React.FC = () => {
  const { connected } = useEnrichedWallet();
  const StyledWalletMenu = styled.div`
    ${appBarMenuPopoverStyles}

    left: 55px;
    top: 75px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 94px;
    width: 339px;

    .ant-btn {
      width: 100%;
    }

    .ant-input-affix-wrapper {
      background: ${black};
    }
  `;

  return connected ? (
    <WalletMenuConnected />
  ) : (
    <StyledWalletMenu>
      <AddressInput />
      <WalletConnect isMobile={true}>
        <CurrentUserBadge />
      </WalletConnect>
    </StyledWalletMenu>
  );
};
